export default __webpack_public_path__ + "static/media/card-rect-57.6cd161d3.svg";